export class PaymentApiModel {
  id: string;
  type: string;
  plainPayload: string;
  provider: string;
  merchantTransactionId: string;
}
